(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nicola-home"] && !Shopify.designMode) return;
  try {
    
function setupMisturaPacks(root=document){
 root.querySelectorAll('.nc-buy-box').forEach(box=>{
  if(box.dataset.ready)return;box.dataset.ready='true';
  const button=box.querySelector('.nc-checkout-button');
  if(!button)return;
  const price=button.querySelector('.nc-checkout-price');
  const section=box.closest('.nc-sauce');
  const image=section?.querySelector('.nc-sauce-photo img');
  const caption=section?.querySelector('.nc-sauce-caption');
  box.querySelectorAll('input[type="radio"]').forEach(input=>{
   input.addEventListener('change',()=>{
    if(!input.checked)return;
    button.href=input.dataset.checkout;
    if(price)price.textContent=input.dataset.price;
    if(image&&input.dataset.image){image.src=input.dataset.image;image.alt=input.dataset.alt||input.dataset.title;}
    if(caption)caption.textContent=input.dataset.title;
   });
  });
 });
}
function setupMisturaFilms(root=document){
 root.querySelectorAll('.nc-film-card').forEach(card=>{
  if(card.dataset.ready)return;card.dataset.ready='true';
  const video=card.querySelector('video'),button=card.querySelector('.nc-film-toggle');
  let userPaused=false,manual=false;
  const load=()=>{const source=video.querySelector('source');if(!source.src){source.src=source.dataset.src;video.load();}};
  const sync=()=>{button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-pressed',String(!video.paused));};
  button.addEventListener('click',()=>{manual=true;load();if(video.paused){userPaused=false;video.play().catch(sync);}else{userPaused=true;video.pause();}sync();});
  video.addEventListener('play',sync);video.addEventListener('pause',sync);
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting){video.pause();return;}if(!reduced.matches&&!navigator.connection?.saveData&&!userPaused&&!manual){load();video.play().catch(sync);}});},{threshold:.45});
  observer.observe(video);reduced.addEventListener('change',()=>{if(reduced.matches)video.pause();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});sync();
 });
}
setupMisturaPacks();setupMisturaFilms();document.addEventListener('shopify:section:load',event=>{setupMisturaPacks(event.target);setupMisturaFilms(event.target);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nicola-product"] && !Shopify.designMode) return;
  try {
    
function setupMisturaProduct(root=document){
 root.querySelectorAll('[data-np-product]').forEach(section=>{
  if(section.dataset.ready)return;section.dataset.ready='true';
  const button=section.querySelector('.np-checkout');
  const price=section.querySelector('[data-np-price]');
  const image=section.querySelector('.np-main-image');
  section.querySelectorAll('.np-option input').forEach(input=>{
   input.addEventListener('change',()=>{
    if(!input.checked)return;
    const form=section.querySelector('[data-mistura-purchase]');if(form){form.querySelector('[name="id"]').value=input.value;form.dispatchEvent(new Event('mistura:variant-change'));}
    if(price)price.textContent=input.dataset.price;
    if(image&&input.dataset.image){image.src=input.dataset.image;image.alt=input.dataset.alt||input.dataset.title;}
    const url=new URL(window.location.href);url.searchParams.set('variant',input.value);window.history.replaceState({},'',url);
   });
  });
 });
}
setupMisturaProduct();document.addEventListener('shopify:section:load',event=>setupMisturaProduct(event.target));

  } catch(e) { console.error(e); }
})();
})();
